import React, { Component } from "react";
import { retrieveToken } from "../../utils/StorageManager";
import constants from "../../constants";
import _ from "lodash";
import PAGE from "../../utils/Destination";
function WithAuthWrapper(WrappedComponent) {
  class NewComponent extends Component {
    async componentDidMount() {
      const token = await retrieveToken(constants.AUTH_TOKEN)
      if (!_.isEmpty(token)) {
        const { history } = this.props;
        history.push(PAGE.DASHBOARD);
      }
    }

    // ...
    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return NewComponent;
}

export default WithAuthWrapper;
